import http from "../http-common";

class CategoryService {
  createCategory(data) {
    return http.post("category/create", data);
  }
  getCategories() {
    return http.get("category/list");
  }
  getCategoryById(id) {
    return http.get("category/detail", { params: { id } });
  }
  updateCategory(data) {
    return http.put("category/update", data);
  }
  deleteCategory(data) {
    return http.delete("category/delete", { params: data });
  }
}

export default new CategoryService();